"use client";

import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className"];
var __jsx = React.createElement;
import React, { useState, useRef } from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { BREAKPOINTS } from "@lib/constants";
import { styled } from "@mui/material/styles";
import Icons from "@modules/icons";
import { useMediaQuery } from "react-responsive";
import useOnClickOutside from "@lib/hooks/use-onclick-outside";
import "styles/hacks/mui-tooltip-hack.css";
import APP_CONFIGURATION from "@lib/app.config";
import { cn } from "@lib/cn";
const MuscleTooltip = _ref => {
  let {
    text,
    tooltipIcon,
    children = __jsx(Icons.info, {
      color: APP_CONFIGURATION.colors.primary_main,
      size: 20
    }),
    placement = "bottom",
    maxWidth = 500,
    padding = "10px 12px 10px 12px",
    backgroundColor = APP_CONFIGURATION.colors.neutral_800,
    textClassName = "tx-psm-regular",
    outerTooltipClassName
  } = _ref;
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const {
    0: open,
    1: setOpen
  } = useState(false);
  const ref = useRef(null);
  useOnClickOutside(ref, () => setOpen(false), open);
  const StyledTooltip = styled(_ref2 => {
    let {
        className
      } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded);
    return __jsx(Tooltip, _extends({}, props, {
      arrow: true,
      classes: {
        popper: className
      }
    }));
  })(_ref3 => {
    let {
      theme
    } = _ref3;
    return {
      ["& .".concat(tooltipClasses.arrow)]: {
        color: backgroundColor
      },
      ["& .".concat(tooltipClasses.tooltip)]: {
        backgroundColor: backgroundColor,
        maxWidth: maxWidth,
        padding: padding,
        opacity: 0.8,
        wordBreak: "break-word",
        whiteSpace: "normal"
      }
    };
  });
  const renderHTMLTooltip = () => {
    return __jsx("div", {
      className: "flex flex-row gap-2 items-center"
    }, __jsx("div", {
      className: "min-w-4 min-h-4"
    }, tooltipIcon), __jsx("span", {
      className: textClassName
    }, text));
  };
  return __jsx(StyledTooltip, {
    title: tooltipIcon ? renderHTMLTooltip() : __jsx("span", {
      className: textClassName
    }, text),
    arrow: true,
    placement: isMobile ? undefined : placement,
    open: isMobile ? open : undefined
  }, __jsx("div", {
    ref: ref,
    className: cn("w-fit", outerTooltipClassName),
    onClick: () => {
      if (isMobile) {
        setOpen(!open);
      }
    }
  }, children));
};
export default MuscleTooltip;